import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IEnquirySearch } from "@/views/inquires/enquiry/enquiryTypes";
import {
    IDtpSearch, IDtpDetail, IDtpInsert, IDtpUpdate, ISupplierOfferSearch, examineFields, ISupplierOfferDetails,
    ISupplierOfferInsert,
    ISupplierOfferUpdate,
    IBillLadingInsert,
    IBillLadingUpdate,
    IBillLadingDetail,
} from "./dtpTypes";



class DtpService {
    async page(searchVo: IDtpSearch, config: object = {}) {
        const apiUrl = "/gtm/shipmentInvoices/listPage";
        return await httpRequest.post<IPage<IDtpDetail>>(apiUrl, searchVo, config);
    }
    async insert(insertVo: IDtpInsert) {
        const apiUrl = "/gtm/shipmentInvoices/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IDtpUpdate) {
        const apiUrl = "/gtm/shipmentInvoices/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async one(id: string) {
        const apiUrl = `/gtm/shipmentInvoices/findByIdOrCode/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //单据生成
    async generate(code: string) {
        const apiUrl = `/gtm/shipmentInvoices/generate/${code}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //提交审核
    async submit(code: string) {
        const apiUrl = `/gtm/shipmentInvoices/submit/${code}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //总经理审批
    async manger(params: examineFields) {
        const apiUrl = `/gtm/shipmentInvoices/manger`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //总监审批
    async examineManager(params: examineFields) {
        const apiUrl = `/gtm/shipmentInvoices/examineManager`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/shipmentInvoices/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //列表导出
    async export(searchVo: IDtpSearch) {
        const appPageUrl = "/gtm/shipmentInvoices/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

    //询价单明细模板下载
    async downloadTpl() {
        const appPageUrl = "/gtm/inquiry/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    /**供应商报价 */
    async pageOffer(searchVo: ISupplierOfferSearch, config: object = {}) {
        const apiUrl = "/gtm/supplierOffer/listPage";
        return await httpRequest.post<IPage<ISupplierOfferDetails>>(apiUrl, searchVo, config);
    }
    async insertOffer(insertVo: ISupplierOfferInsert) {
        const apiUrl = "/gtm/supplierOffer/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async updateOffer(updateVo: ISupplierOfferUpdate) {
        const apiUrl = "/gtm/supplierOffer/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async oneOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/findByIdOrCode/${id}`;
        return await httpRequest.get<ISupplierOfferDetails>(apiUrl);
    }
    async disableOffer(id: string) {
        const apiUrl = `/gtm/supplierOffer/disable/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //出口报价
    async transferOffer(vo: { "code": string, "shopCode": string }) {
        const apiUrl = "/gtm/supplierOffer/transfer";
        return await httpRequest.post<string>(apiUrl, vo);
    }
    //供应商报价明细导出
    async offerExport(HRcode: string, shopCode: string) {
        const appPageUrl = `/gtm/supplierOffer/exportDetails/${HRcode}/${shopCode}`;
        return await httpRequest.getFile(appPageUrl);
    }
    //供应商报价模板下载
    async offerDownloadTpl() {
        const appPageUrl = "/gtm/supplierOffer/detail/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

    //提单管理
    // 新增
    async billLadingInsert(params: IBillLadingInsert) {
        const apiUrl = "/gtm/billLading/insert";
        return await httpRequest.post<string>(apiUrl, params);
    }
    //编辑
    async billLadingUpdate(params: IBillLadingUpdate) {
        const apiUrl = "/gtm//billLading/update";
        return await httpRequest.post<string>(apiUrl, params);
    }
    //分页
    async billLadingPage(searchVo: IEnquirySearch, config: object = {}) {
        const apiUrl = "/gtm/billLading/search/pg";
        return await httpRequest.post<IPage<IBillLadingDetail>>(apiUrl, searchVo, config);
    }
    //删除
    async billLadingDelete(id:string){
        const apiUrl = `/gtm//billLading/delete/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
     // 修改审批时间
     offerTime(updateVo: any){
        const apiUrl = `/gtm//audit/update`
        return   httpRequest.post<string>(apiUrl, updateVo);
    }

}

export const enquiryService = new DtpService();
